<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-right">
          <router-link class="btn btn-primary" :to="{ name: 'vouchers.create' }">
            <font-awesome-icon :icon="['fal', 'plus-circle']" />
            Create
          </router-link>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <advanced-filter
          :refs="$refs"
          :select-filters="selectFilters"
          :date-range="true"
          @ready="init"
        />

        <v-server-table
          v-if="initialised"
          ref="table"
          url="/vouchers"
          :columns="columns"
          :options="options"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import entity from "../../mixins/entity";
import format from "../../mixins/format";
import AdvancedFilter from "../../components/common/AdvancedFilter.vue";

const columns = ["code", "description", "type", "value", "start", "expiry", "limit", "actions"];

export default {
  components: {
    AdvancedFilter,
  },

  mixins: [entity, format],

  data() {
    return {
      initialised: false,
      userFilter: null,

      selectFilters: {
        type: {
          options: [
            {
              label: "Amount",
              value: "Amount",
            },
            {
              label: "Percentage",
              value: "Percentage",
            },
          ],
        },

        is_valid: {
          value: "1",
          options: [
            {
              label: "Yes",
              value: "1",
            },
            {
              label: "No",
              value: "0",
            },
          ],
        },
      },

      columns,
      options: {
        advancedFilter: true,

        columnsClasses: {
          actions: "text-center",
        },

        templates: {
          value: (h, o) => (o.type === "Amount" ? `$${o.value}` : `${o.value}%`),
          start: (h, o) => this.formatLocalDate(o.start, "DD MMM YYYY"),
          expiry: (h, o) => this.formatLocalDate(o.expiry, "DD MMM YYYY"),
          actions: (h, o) => this.entityEdit(h, o, "vouchers", this.$refs),
        },
      },
    };
  },

  methods: {
    init() {
      this.initialised = true;
    },
  },
};
</script>
